import React from 'react';

import { DateTime } from 'luxon';
import { useIntl } from 'react-intl';

import { hockeyFormatter, constants } from '@nhl/formatter-utilities';

import genericSelectors from '../../../redux/genericSelectors';
import { commonMessages } from '../../../utility/commonMessages';

import {
    LogoContainer,
    MatchupContainer,
    ScoreboardContainer,
    ScoreDisplay,
    GameState,
    GameStateTime,
    TeamContainer,
    TeamName,
} from './styles';

const Scoreboard = ({ game, teamData }) => {
    const intl = useIntl();
    const { id, gameFormat, period, gameStateId, homeScore, homeTeamId, visitingScore, visitingTeamId } = game;
    const visitingTeamName = genericSelectors.getTeam(teamData, visitingTeamId)?.fullName;
    const homeTeamName = genericSelectors.getTeam(teamData, homeTeamId)?.fullName;

    const otText = intl.formatMessage(commonMessages.misc.overtime);
    const soText = intl.formatMessage(commonMessages.misc.shootout);
    const locale = window.__SITE_LANGUAGE_CODE__;
    const periodDescription = hockeyFormatter.periodsFormatter(period, gameFormat, otText, soText, locale);

    const gameStateTime =
        gameStateId >= constants.SOFT_FINAL
            ? intl.formatMessage(commonMessages.misc.final)
            : intl.formatMessage(commonMessages.misc.period);

    return (
        <MatchupContainer>
            <TeamContainer>
                <TeamName>{visitingTeamName}</TeamName>

                <LogoContainer>{genericSelectors.createTeamDisplay(id, visitingTeamId, teamData)}</LogoContainer>
            </TeamContainer>

            {gameStateId <= constants.PREGAME ? (
                <ScoreboardContainer>
                    <GameState>
                        {DateTime.fromISO(game.easternStartTime, { zone: constants.ET_TIMEZONE }).toLocaleString(
                            DateTime.DATETIME_MED,
                        )}{' '}
                        ET
                    </GameState>
                </ScoreboardContainer>
            ) : (
                <ScoreboardContainer>
                    <ScoreDisplay>{visitingScore}</ScoreDisplay>
                    <GameState>
                        {periodDescription}
                        <GameStateTime>{gameStateTime}</GameStateTime>
                    </GameState>
                    <ScoreDisplay>{homeScore}</ScoreDisplay>
                </ScoreboardContainer>
            )}

            <TeamContainer homeTeam>
                <TeamName>{homeTeamName}</TeamName>

                <LogoContainer>{genericSelectors.createTeamDisplay(id, homeTeamId, teamData)}</LogoContainer>
            </TeamContainer>
        </MatchupContainer>
    );
};

export default Scoreboard;
